<div class="user-profile-settings-container no-select">
  <div class="widget-div">
    <app-shared-widget-container-component>
      <div title class="widget-div-heading">
        <app-display-icon
          [tooltip]="tooltips.editAccessGranted"
          [icon]="icons.lockOpenOutline">
        </app-display-icon>
        <div>Purchase order</div>
        <app-display-icon
          [tooltip]="layoutSettingsTooltip"
          [icon]="icons.infoSlabCircleOutline"
          [colour]="iconColours.secondary">
        </app-display-icon>
      </div>
      <div block>
        <form>
          <div class="form-column">
            <div class="form-control-div">
              <label for="purchase-order-layout">Purchase order layout</label>
              <app-shared-custom-select
                id="purchase-order-layout"
                (selectionChange)="onLayoutChange($event)"
                [allowMultiple]="false"
                [allowSelectAll]="false"
                [isDisabled]="loading()"
                [maxSelections]="1"
                [placeholder]="'Select a layout'"
                [setOptions]="layoutOptions()"
                [showActionButtons]="false"
                [showChips]="false"
                [showSearchBar]="false">
              </app-shared-custom-select>
            </div>

            @if (isLocalLayout()) {
              <p class="layout-hint">
                This PDF is generated on the client’s server. It stays the default until you choose another layout.
              </p>
            } @else {
              <div class="form-control-div">
                <label for="purchase-order-colour">Colour</label>
                <app-shared-custom-select
                  id="purchase-order-colour"
                  (selectionChange)="onAccentChange($event)"
                  [allowMultiple]="false"
                  [allowSelectAll]="false"
                  [isDisabled]="loading()"
                  [maxSelections]="1"
                  [placeholder]="'Select a colour'"
                  [setOptions]="colourOptions()"
                  [showActionButtons]="false"
                  [showChips]="false"
                  [showSearchBar]="false">
                </app-shared-custom-select>
              </div>
            }

            @if (error(); as message) {
              <p class="layout-error">{{ message }}</p>
            }

            @if (isPreviewLoading()) {
              <div class="layout-preview-loading" role="status" aria-live="polite" aria-busy="true">
                <app-shared-loading-g [animation]="loadingAnimation"></app-shared-loading-g>
                <p>Generating purchase order preview…</p>
              </div>
            } @else if (previewSrc(); as src) {
              <iframe class="layout-preview" title="Purchase order preview" [src]="src"></iframe>
            }
          </div>
        </form>
      </div>
      <div actions class="widget-actions">
        @if (!isLocalLayout()) {
          <button
            type="button"
            class="action-button"
            [disabled]="isPreviewLoading() || isPageLoading()"
            (click)="preview()">
            <app-display-icon
              [colour]="isPreviewLoading() || isPageLoading() ? iconColours.disabled : iconColours.secondary"
              [tooltip]="isPreviewLoading() ? 'Generating preview…' : 'Preview purchase order PDF'"
              [icon]="icons.eyeOutline">
            </app-display-icon>
          </button>
        }
        @if (hasEditsBeenEdited()) {
          <button type="button" class="action-button" [disabled]="loading()" (click)="onRevertForm('layout')">
            <app-display-icon
              [colour]="loading() ? iconColours.disabled : iconColours.secondary"
              [tooltip]="tooltips.undoChanges"
              [icon]="icons.undo">
            </app-display-icon>
          </button>
        }
        @if (hasEditsBeenEdited()) {
          <button type="button" class="action-button" [disabled]="isSaveDisabled()" (click)="onSubmitForm('layout')">
            <app-display-icon
              [colour]="isSaveDisabled() ? iconColours.disabled : iconColours.secondary"
              [tooltip]="tooltips.saveChanges"
              [icon]="icons.contentSaveOutline">
            </app-display-icon>
          </button>
        }
      </div>
    </app-shared-widget-container-component>
  </div>

  <div class="ups-container-action-bar widget-actions">
    <button type="button" class="action-button" [disabled]="!hasEditsBeenEdited() || loading()" (click)="onRevertForm('all')">
      <app-display-icon
        [colour]="!hasEditsBeenEdited() || loading() ? iconColours.disabled : iconColours.secondary"
        [tooltip]="tooltips.undoAllChanges"
        [icon]="icons.undo">
      </app-display-icon>
      Undo Changes
    </button>
    <button type="button" class="action-button" [disabled]="isSaveDisabled()" (click)="onSubmitForm('all')">
      <app-display-icon
        [colour]="isSaveDisabled() ? iconColours.disabled : iconColours.secondary"
        [tooltip]="tooltips.saveAllChanges"
        [icon]="icons.contentSaveOutline">
      </app-display-icon>
      Save All
    </button>
  </div>
</div>
